import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './cambio_contrasena_creador.css';

const CambioContrasenaCreador = () => {
  const navigate = useNavigate();

  const [claveActual, setClaveActual] = useState('');
  const [claveNueva, setClaveNueva] = useState('');
  const [claveRepetir, setClaveRepetir] = useState('');

  const [verActual, setVerActual] = useState(false);
  const [verNueva, setVerNueva] = useState(false);
  const [verRepetir, setVerRepetir] = useState(false);

  const [errorBanner, setErrorBanner] = useState('');

  // ==================== VALIDACIONES ====================
  const tiene12Chars = claveNueva.length >= 12;
  const tiene2Mayusculas = (claveNueva.match(/[A-Z]/g) || []).length >= 2;
  const tiene1Minuscula = /[a-z]/.test(claveNueva);
  const tiene1Numero = /[0-9]/.test(claveNueva);
  const tiene1Especial = /[.,\-_!@#$%^&*()+={}[\]|\\:;"'<>?/`~]/.test(claveNueva);

  const todosRequisitos =
    tiene12Chars &&
    tiene2Mayusculas &&
    tiene1Minuscula &&
    tiene1Numero &&
    tiene1Especial;

  const requisitos = [
    { texto: '12 caracteres como minimo', cumplido: tiene12Chars },
    { texto: 'Dos letras mayusculas como minimo', cumplido: tiene2Mayusculas },
    { texto: 'Una letra miniscula como minimo', cumplido: tiene1Minuscula },
    { texto: 'Un numero como minimo', cumplido: tiene1Numero },
    { texto: 'Un caracter especial como minimo (. , - _ etc)', cumplido: tiene1Especial },
  ];

  // ==================== HANDLERS ====================
  const handleGuardar = async () => {
    setErrorBanner('');

    if (!claveActual) {
      setErrorBanner('Debes ingresar tu contraseña actual.');
      return;
    }

    if (!todosRequisitos) {
      setErrorBanner('La nueva contraseña no cumple con los requisitos minimos.');
      return;
    }

    if (claveNueva !== claveRepetir) {
      setErrorBanner('Las contraseñas nuevas no coinciden.');
      return;
    }

try {
      const response = await fetch(`${process.env.REACT_APP_AUTH_CREADOR_URL}/cambio_clave.php`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ clave_actual: claveActual, clave_nueva: claveNueva })
      });
      const data = await response.json();
      if (!data.success) {
        setErrorBanner(data.message);
        return;
      }

      alert('✓ Contraseña cambiada exitosamente. Inicia sesión con tu nueva clave.');
      window.location.href = '/acceso-publicar';
    } catch (error) {
      console.error('Error al cambiar contraseña:', error);
      setErrorBanner('Error al procesar el cambio. Intenta nuevamente.');
    }
  };

  const handleCancelar = () => {
    navigate('/panel_creador');
  };

  // ==================== RENDER ====================
  return (
    <>
      <div className="cambio-clave-container">
      <div className="cambio-clave-card">

        <h2 className="cambio-clave-titulo">CAMBIO CLAVE</h2>

        {/* Contraseña actual */}
        <div className="campo-grupo">
          <label>Contraseña actual</label>
          <div className="campo-input-wrapper">
            <input
              type={verActual ? 'text' : 'password'}
              value={claveActual}
              onChange={(e) => setClaveActual(e.target.value)}
              placeholder="Ingresa tu contraseña actual"
            />
<button className="btn-ojo" onClick={() => setVerActual(!verActual)}>
  {verActual ? (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#666" strokeWidth="2">
      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
      <line x1="1" y1="1" x2="23" y2="23"/>
    </svg>
  ) : (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#666" strokeWidth="2">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
      <circle cx="12" cy="12" r="3"/>
    </svg>
  )}
</button>
          </div>
        </div>

        {/* Nueva contraseña */}
        <div className="campo-grupo">
          <label>Nueva contraseña</label>
          <div className="campo-input-wrapper">
            <input
              type={verNueva ? 'text' : 'password'}
              value={claveNueva}
              onChange={(e) => setClaveNueva(e.target.value)}
              placeholder="Ingresa tu nueva contraseña"
            />
<button className="btn-ojo" onClick={() => setVerNueva(!verNueva)}>
  {verNueva ? (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#666" strokeWidth="2">
      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
      <line x1="1" y1="1" x2="23" y2="23"/>
    </svg>
  ) : (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#666" strokeWidth="2">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
      <circle cx="12" cy="12" r="3"/>
    </svg>
  )}
</button>
          </div>
        </div>

        {/* Requisitos */}
        <div className="requisitos-box">
          {requisitos.map((req, idx) => (
            <div key={idx} className={`requisito-item ${req.cumplido ? 'cumplido' : ''}`}>
              <span className="requisito-icono">{req.cumplido ? '\u2713' : '\u25CB'}</span>
              <span>{req.texto}</span>
            </div>
          ))}
        </div>

        {/* Repetir contrase�a */}
        <div className="campo-grupo">
          <label>Repite la contraseña</label>
          <div className="campo-input-wrapper">
            <input
              type={verRepetir ? 'text' : 'password'}
              value={claveRepetir}
              onChange={(e) => setClaveRepetir(e.target.value)}
              placeholder="Repite tu nueva contraseña"
            />
<button className="btn-ojo" onClick={() => setVerRepetir(!verRepetir)}>
  {verRepetir ? (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#666" strokeWidth="2">
      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
      <line x1="1" y1="1" x2="23" y2="23"/>
    </svg>
  ) : (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#666" strokeWidth="2">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
      <circle cx="12" cy="12" r="3"/>
    </svg>
  )}
</button>
          </div>
        </div>

        {/* Banner de error */}
        {errorBanner && (
<div className="banner-error">
  {'\u2718'} {errorBanner}
</div>
        )}

        {/* Botones */}
        <div className="cambio-clave-botones">
          <button className="btn-cc-cancelar" onClick={handleCancelar}>
            Cancelar
          </button>
          <button className="btn-cc-guardar" onClick={handleGuardar}>
            Guardar cambios
          </button>
        </div>

</div>
    </div>

      {/* Footer */}
      <footer className="home-footer">
        <div className="home-footer-top">
          <div className="home-footer-redes">
            <a href="https://www.instagram.com/ulalaaaoficial" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://www.tiktok.com/@ulalaaaoficial2" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-tiktok"></i>
            </a>
            <a href="#" className="home-footer-social-link">
              <i className="fab fa-youtube"></i>
            </a>
            <a href="https://wa.me/56929674732" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-whatsapp"></i>
            </a>
            <a href="#" className="home-footer-social-link">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{width:'22px',height:'22px'}}>
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.259 5.63 5.905-5.63zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </a>
            <a href="https://t.me/+56929674732" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-telegram"></i>
            </a>
          </div>
          <div className="home-footer-logo">
            <img
              src={`${process.env.REACT_APP_UPLOADS_URL}/logotipo_new8.jpg`}
              alt="Ulalaaa Logo"
              className="home-footer-logo-img"
            />
          </div>
          <div className="home-footer-legal-links">
            <a href="/textos-legales#terminos" className="home-footer-legal-btn">Información Legal - Términos y Condiciones</a>
            <a href="/textos-legales#privacidad" className="home-footer-legal-btn">Política de Privacidad</a>
          </div>
        </div>
        <div className="home-footer-texto">
          Ulalaaa, es un sitio web exclusivo para mayores de 18 años, tanto para las personas publicadas como las que lo visitan, las personas publicadas son verificadas de forma rigurosa, el cual han dado su consentimiento para ser publicadas, este sitio no es una agencia, es solo un medio publicitario que no interviene con ninguna relación laboral con las personas publicadas.
        </div>
        <div className="home-footer-copyright">
          ©2026 Ulalaaa - Todos los derechos Reservados.
        </div>
</footer>
    </>
  );
};

export default CambioContrasenaCreador;